import { render, staticRenderFns } from "./colorSize.vue?vue&type=template&id=54da4586&"
import script from "./colorSize.vue?vue&type=script&lang=js&"
export * from "./colorSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports